// Parent-side add / edit / remove follow-up questions on a webinar form builder row.
import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "addPanel",
    "editPanel",
    "questionSelect",
    "addButton",
    "addAnotherButton",
    "noFollowUpLabel",
    "existingFollowUp"
  ];

  static values = {
    addUrl: String,
    updateUrl: String,
    removeUrl: String,
    parentFieldId: Number
  };

  showAdd(event) {
    event.preventDefault();
    if (this.hasAddPanelTarget) this.addPanelTarget.classList.remove("d-none");
    if (this.hasAddButtonTarget) this.addButtonTarget.classList.add("d-none");
    if (this.hasAddAnotherButtonTarget) this.addAnotherButtonTarget.classList.add("d-none");
    if (this.hasNoFollowUpLabelTarget) this.noFollowUpLabelTarget.classList.add("d-none");
  }

  hideAdd(event) {
    if (event) event.preventDefault();
    if (this.hasAddPanelTarget) this.addPanelTarget.classList.add("d-none");
    if (this.hasAddButtonTarget) this.addButtonTarget.classList.remove("d-none");
    if (this.hasAddAnotherButtonTarget) this.addAnotherButtonTarget.classList.remove("d-none");
    if (this.hasNoFollowUpLabelTarget) this.noFollowUpLabelTarget.classList.remove("d-none");
  }

  showEdit(event) {
    event.preventDefault();
    const id = event.currentTarget.dataset.followUpId;
    this.editPanelTargets.forEach((panel) => {
      panel.classList.toggle("d-none", panel.dataset.followUpId !== id);
    });
  }

  hideEdit(event) {
    event.preventDefault();
    const id = event.currentTarget.dataset.followUpId;
    this.editPanelTargets.forEach((panel) => {
      if (panel.dataset.followUpId === id) panel.classList.add("d-none");
    });
  }

  submitAdd(event) {
    event.preventDefault();
    if (!this.addUrlValue) return;

    const triggers = Array.from(this.element.querySelectorAll("[data-add-trigger]:checked")).map(
      (el) => el.value
    );
    const questionId = this.hasQuestionSelectTarget ? this.questionSelectTarget.value : "";

    if (!triggers.length) {
      alert("Select at least one answer that shows the follow-up question.");
      return;
    }
    if (!questionId) {
      alert("Select a library question for the follow-up.");
      return;
    }

    this.submitExternalPost(this.addUrlValue, {
      parent_registration_form_field_id: this.parentFieldIdValue,
      qualification_question_id: questionId,
      "show_when_option_ids[]": triggers
    });
  }

  submitEdit(event) {
    event.preventDefault();
    if (!this.updateUrlValue) return;

    const id = event.currentTarget.dataset.followUpId;
    const triggers = Array.from(
      this.element.querySelectorAll(`[data-edit-trigger][data-follow-up-id="${id}"]:checked`)
    ).map((el) => el.value);

    if (!triggers.length) {
      alert("Select at least one answer that shows the follow-up question.");
      return;
    }

    this.submitExternalPost(
      this.updateUrlValue,
      {
        registration_form_field_id: id,
        "show_when_option_ids[]": triggers
      },
      "PATCH"
    );
  }

  removeFollowUp(event) {
    event.preventDefault();
    if (!this.removeUrlValue) return;

    const id = event.currentTarget.dataset.followUpId;
    if (!id) return;
    if (!window.confirm("Remove this follow-up question from this webinar?")) return;

    this.submitExternalPost(
      this.removeUrlValue,
      { registration_form_field_id: id },
      "DELETE"
    );
  }

  submitExternalPost(url, params, method = "POST") {
    const form = document.createElement("form");
    form.method = "POST";
    form.action = url;
    form.style.display = "none";

    const csrf = document.querySelector("meta[name='csrf-token']")?.content;
    if (csrf) this.appendHidden(form, "authenticity_token", csrf);

    if (method !== "POST") {
      this.appendHidden(form, "_method", method);
    }

    Object.entries(params).forEach(([name, value]) => {
      if (Array.isArray(value)) {
        value.forEach((item) => this.appendHidden(form, name, item));
      } else {
        this.appendHidden(form, name, value);
      }
    });

    document.body.appendChild(form);
    form.submit();
  }

  appendHidden(form, name, value) {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    form.appendChild(input);
  }
}
